var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"daily-events"},[_c('dialog-sign',{ref:"dialogSign"}),_vm._v(" "),_c('dialog-tag',{ref:"dialogTag"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }